var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{attrs:{"method":"post","accept-charset":"UTF-8","enctype":"multipart/form-data"},on:{"submit":function($event){$event.stopPropagation();return _vm.onSubmit.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }